export const speech = {
	name: 'speech',
	title: 'Speech',
	content:
		'<path d="M21.75,18.75H11.25l-6,4.5v-4.5h-3a1.5,1.5,0,0,1-1.5-1.5v-15A1.5,1.5,0,0,1,2.25.75h19.5a1.5,1.5,0,0,1,1.5,1.5v15A1.5,1.5,0,0,1,21.75,18.75Z" fill="none" stroke="#000000" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5px"></path><line x1="5.25" y1="7.5" x2="18.75" y2="7.5" fill="none" stroke="#000000" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5px"></line><line x1="5.25" y1="12" x2="15.75" y2="12" fill="none" stroke="#000000" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5px"></line>',
};
